module.exports = __webpack_public_path__ + "static/media/Raleway-Light.4c6fb17e.ttf";